import { Stack } from "@dropbox/dig-foundations";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Shown_DashEmptyStateComponent } from "@mirage/analytics/events/types/shown_dash_empty_state_component";
import { useTheme } from "@mirage/service-settings/theming/useTheme";
import { EmptyStateCard } from "@mirage/shared/empty-state-ui/EmptyStateCard";
import { useWelcomeStacks } from "@mirage/stacks/hooks";
import i18n from "@mirage/translations";
import { useEffect, useRef } from "react";
import { NoMoreActivityItems } from "../ActivityList/NoMoreActivityItems";
import { WelcomeStackActivity } from "./WelcomeStackActivity";

export const ActivityListEmptyState = () => {
  const loggedExposure = useRef(false);
  const { reportPapEvent } = useMirageAnalyticsContext();
  const welcomeStacks = useWelcomeStacks();
  const isDarkMode = useTheme();

  useEffect(() => {
    if (!loggedExposure.current) {
      loggedExposure.current = true;
      reportPapEvent(
        PAP_Shown_DashEmptyStateComponent({
          dashActionSurface: "start_page",
          actionSurfaceComponent: "activity_feed",
        }),
      );
    }
  }, [reportPapEvent]);

  if (welcomeStacks.length > 0) {
    return (
      <Stack gap="Micro Small">
        <WelcomeStackActivity
          stack={welcomeStacks[0]}
          isDarkMode={isDarkMode}
        />
        <NoMoreActivityItems />
      </Stack>
    );
  }

  return <EmptyStateCard message={i18n.t("activity_feed_empty_state_text")} />;
};
